<nav class="container-pagination" id="container-ResultsPaginationComponent" *ngIf="displayPagination">
    <p id="paginglabel" class="sr-only">Pagination</p>

    <ul aria-labelledby="paginglabel">
        <li>
            <a (click)="pushPageNavToGA('prev#' + previousPage.link.page)" [routerLink]="[profile, 'results']" [queryParams]="previousPage.link" class="btn prev" [ngClass]="{ 'disabled': previousPage.active === false }" rel="prev" [attr.aria-label]="previousPage.link.page + ' Page'">
                <svg class="gr-left-open" aria-label="Previous page">
                    <use xlink:href="./assets/img/icons.svg#gr-left-open"></use>
                </svg>
            </a>
        </li>
        <li *ngFor="let l of displayPaginationLinks">
          <a (click)="pushPageNavToGA(l.link.page)" [routerLink]="[profile, 'results']" [queryParams]="l.link" [attr.aria-label]="l.link.page + ' Page'" *ngIf="!l.active">{{ l.link.page }}</a>
          <p *ngIf="l.active" [attr.aria-label]="'Current Page: ' + l.link.page" tabindex="0">{{ l.link.page }}</p>
        </li>

        <li>
            <a (click)="pushPageNavToGA('next#' +nextPage.link.page)" [routerLink]="[profile, 'results']" [queryParams]="nextPage.link" class=" btn next" [ngClass]="{ 'disabled': nextPage.active === false }" rel="next" [attr.aria-label]="nextPage.link.page + ' Page'">
                <svg class="gr-right-open" aria-label="Next page">
                    <use xlink:href="./assets/img/icons.svg#gr-right-open"></use>
                </svg>
            </a>
        </li>
    </ul>
</nav>
